import { QueryHookOptions, gql, useQuery } from '@apollo/client'
import { CartQuery, CartQueryVariables } from 'types/graphql'
import { cartFieldsFragment } from './cartFieldsFragment'

export const getCartQuery = gql`
  ${cartFieldsFragment}

  query Cart($id: ID!) {
    cart(id: $id) {
      ...CartFields
    }
  }
`

export const useCart = (options?: QueryHookOptions<CartQuery, CartQueryVariables>) => {
  return useQuery<CartQuery, CartQueryVariables>(getCartQuery, { fetchPolicy: 'no-cache', ...options })
}
